module.exports = __webpack_public_path__ + "img/required.0dcb2984.svg";